import { createSelector } from 'reselect';
import lodash from 'lodash';
import type { RootState } from 'store';

import theme from '../constants/theme';

const getThemeOverrides = (state: RootState) => state.config?.themeOverrides;

export default createSelector([getThemeOverrides], overrides => {
  const safeOverrides: ThemeOverrides = lodash
    .chain(overrides)
    .pickBy()
    .mapValues(property => lodash.pickBy(property, instance => instance != null))
    .value();

  const outputTheme = lodash
    .chain(theme(safeOverrides.constants))
    .cloneDeep()
    .merge(safeOverrides)
    .value();

  return outputTheme;
});
